import React, { useState, useEffect } from 'react'
import { Userstamp, exstamp, loadImage, optionAlert } from '../project'

function Mainstamp({ userId, fresh, setStampidProp, notmain, stampnum }) {
    const [imageSrcs, setImageSrcs] = useState(null)

    useEffect(() => {
        if (!userId || userId === 'example') return

        Userstamp(userId)
            .then((response) => {
                const list = response && response.data ? response.data : []
                if (!list.length) {
                    optionAlert(
                        'success',
                        '날인을 등록해주세요',
                        '',
                        '날인등록 페이지로 이동',
                        '/Mypage/Myinfo/sealingmethod',
                    )
                    return
                }

                let targetStamp = null

                if (!notmain) {
                    targetStamp = list.find((v) => Number(v.main) === 1)
                } else {
                    targetStamp =
                        list.find((v) => String(v.id) === String(stampnum)) || list.find((v) => Number(v.main) === 1)
                }

                if (!targetStamp) return

                // console.log('선택된 도장:', targetStamp)
                // console.log('setStampidProp 전달 여부:', typeof setStampidProp)
                // console.log('targetStamp.id:', targetStamp.id)

                if (typeof setStampidProp === 'function') {
                    setStampidProp(targetStamp.id)
                }

                loadImage(targetStamp, setImageSrcs)
            })
            .catch((err) => {
                console.error('Userstamp 오류:', err)
            })
    }, [fresh, userId, stampnum, notmain, setStampidProp])

    return (
        <div className="stampbox">
            {imageSrcs && imageSrcs.base64 ? (
                <img src={imageSrcs.base64} alt="stamp" />
            ) : (
                <span className="stampbox">{exstamp}</span>
            )}
        </div>
    )
}

export default Mainstamp
